import React, { useEffect, useRef, useState, useContext } from "react";
import { IoCloseOutline } from "react-icons/io5";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import API from "src/network";
import RestrictionMsgModal from "src/Components/RestrictionMsgModal";
import Post from "../components/Post";
import { useSelector } from "react-redux";
import { isChildSayMessageType, updateItemSayCount } from "src/Utils/commonUtils";
import {
  CommonModalContext,
  ModalType,
} from "src/context/CommonModalContext/CommonModalContext";

const SearchTagModal = ({
  open,
  onClose,
  hashTag,
  tenantId: selectedTenantId,
  tagId,
  isTrendingTag,
  parentMsgId,
  tagActivityTenantId,
  isActionDisabled: propIsActionDisabled = false,
  onActionSuccess,
}) => {
  const [data, setData] = useState({});
  const [notificationParentPost, setNotificationParentPost] = useState({});
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [isPrivate, setIsPrivate] = useState(false);
  const [childSaysLoading, setChildSaysLoading] = useState(false);
  const [childSaysData, setChildSaysData] = useState({});
  const [followData, setFollowData] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [voteUpData, setVoteUpData] = useState({});
  const [hasRestrictionSays, setHasRestrictionSays] = useState(false);
  const [hasRestrictionSaysStatus, setHasRestrictionSaysStatus] = useState("");
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const viewTenantInfo = userDetails?.userData?.viewActivityUserTenantInfo;

  const isCommunityPrivate =
    propIsActionDisabled ||
    (viewTenantInfo &&
      Object.keys(viewTenantInfo).length > 0 &&
      viewTenantInfo?.isCommunityPrivate === "Y" &&
      viewTenantInfo?.isFollowed === "N") ||
    false;

  const tenantId =
    tagActivityTenantId ||
    (viewTenantInfo &&
      Object.keys(viewTenantInfo).length > 0 &&
      viewTenantInfo?.tenantId) ||
    userDetails?.userData?.tenantId ||
    "";

  const commonModalContext = useContext(CommonModalContext);

  const handleHashTagClick = (tag) => {
    if (typeof tag === "object") {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
        hashTag: tag.hashtag,
        tagActivityTenantId: tag.tenantId,
        isActionDisabled: isCommunityPrivate,
        onActionSuccess,
      });
    } else {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
        hashTag: tag,
        isActionDisabled: isCommunityPrivate,
        onActionSuccess,
      });
    }
  };

  const postRef = useRef(null);

  useEffect(() => {
    if (isTrendingTag && selectedTenantId && tagId) {
      (async () => {
        try {
          setLoading(true);
          const response = await API.fetchTagDetails(selectedTenantId, tagId);
          setData({
            ...response.data,
            wantedH:
              Array.isArray(response.data.messageList) &&
              response.data.messageList.length > 0
                ? response.data.messageList[0]?.tag[0]
                : "",
          });
        } catch (e) {
          console.log(e);
        } finally {
          setLoading(false);
        }
      })();
    } else if (hashTag) {
      (async () => {
        try {
          setLoading(true);
          const formData = new FormData();
          formData.append("tag", hashTag);
          formData.append("hme", "trnd");
          formData.append("tid", tenantId);
          const res = await API.tagSearch(formData);
          setData(res.data);
        } catch (e) {
          console.log(e);
        } finally {
          setLoading(false);
        }
      })();
    } else if (parentMsgId) {
      (async () => {
        try {
          setLoading(true);
          const res = await API.showNotificationParentPost(parentMsgId);
          console.log(`notification parent res data:`, res.data);
          setData(res.data);
          setNotificationParentPost(res.data.messageFeed[0]);
        } catch (e) {
          console.log(e);
        } finally {
          setLoading(false);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hashTag, parentMsgId, tagId]);

  useEffect(() => {
    if (isTrendingTag) {
      setList(data?.messageList || []);
    } else if (parentMsgId) {
      // setList(data?.messageFeed || []);
      const normalizedList = (data?.messageFeed || []).map((item) => ({
        ...item,
        id: item.message_id,
        uimage: item.mainuserdata.uimage,
        displayName: item.mainuserdata.displayName,
        locName: item.loc_name,
        Message: item.message_text,
        msg: item.message_text,
        followCount: item.follow_count,
        voteUp: item.vote_up_count,
      }));
      setList(normalizedList);
    } else {
      const { messageList } = data || {};
      let filteredList = [];
      if (Array.isArray(messageList)) {
        filteredList = messageList.filter(
          (eachMsg) => eachMsg?.Keyword_ID === "#TAG",
        );
      }
      setList(filteredList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (list.length > 0) {
      // visible child says
      setTimeout(function () {
        postRef.current && postRef.current?.setVisibleChildSays(list[0]?.id);
      }, 200);
    }
  }, [list]);

  // useEffect(() => {
  //   const { messageList } = data || {};
  //   let list = [];
  //   let isPrivate = false;
  //   if (messageList && Array.isArray(messageList)) {
  //     if (messageList.length >= 2) {
  //       const message1 = messageList[1];
  //       const { followStatus, hashTagType, hashtagAccess } = message1 || {};
  //       isPrivate = (followStatus === "N" && ("" + hashTagType).toLowerCase() === "private" && hashtagAccess === "N");
  //       list = isPrivate ? [...messageList.slice(0, 1)] : [...messageList];
  //     } else {
  //       list = [...messageList];
  //     }
  //     setIsPrivate(isPrivate);
  //     setList(list);
  //   }
  // }, [data]);

  const fetchChildSaysData = async (id, popCols, limit) => {
    setChildSaysLoading(true);
    try {
      const response = await API.fetchChildSaysData(id, popCols, limit);
      setChildSaysData(response.data);
    } catch (e) {
      console.error(e);
    } finally {
      setChildSaysLoading(false);
    }
  };

  const formatTagTitle = (tag) => {
    if (!tag) return "";
    const tagStr = String(tag).trim();
    if (tagStr.length <= 32) {
      return tagStr;
    }
    return `${tagStr.slice(0, 32)}...`;
  };

  const getNotificationActivityType = (key) => {
    if (key === "OpenASK") return "ASK";
    if (key === "OpenSAY") return "SAY";
    if (key === "impupdate") return "UPDATE";
    if (key === "hashTAG") {
      const tagText = notificationParentPost?.message_text?.split(" ")[0] || "";
      return formatTagTitle(tagText);
    }
  };

  const postChildSayData = async (id, msg, lnglat, locSelect, attachment) => {
    try {
      setChildSaysLoading(true);
      const formdata = new FormData();
      formdata.append("Message", msg);
      if (attachment) {
        formdata.append("file", attachment);
      }
      const response = await API.postChildSayData(
        id,
        formdata,
        lnglat,
        locSelect,
      );
      const status = response?.data?.status || "";
      if (response?.data?.justFollowed) {
        onActionSuccess?.(() => {});
      }
      if (status === "New Hash") {
        return "New Hash";
      } else if (status === "E_Say" || status === "E") {
        setHasRestrictionSays(true);
        setHasRestrictionSaysStatus(status);
        return status;
      } else {
        await fetchChildSaysData(id);
        updateSaysCountInList(id, "add");
        return status;
      }
    } catch (e) {
      console.error(e);
    } finally {
      setChildSaysLoading(false);
    }
  };

  const fetchFollowData = async (id, status) => {
    try {
      const response = await API.fetchFollowUnfollowData(id, status);
      setFollowData(response.data);
      if (response?.data?.justFollowed) {
        onActionSuccess?.(() => {});
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchVoteUpStatus = async (id, status) => {
    try {
      const response = await API.fetchVoteUpStatus(id, status);
      setVoteUpData(response.data);
      if (response?.data?.justFollowed) {
        onActionSuccess?.(() => {});
      }
    } catch (e) {
      console.error(e);
    }
  };

  const deleteMessage = async (id, type, Parent_ID) => {
    try {
      const response = await API.deleteMessage(id);
      if (response) {
        if (isChildSayMessageType(type)) {
          console.log("childSaysData", childSaysData);
          const updatedData = childSaysData.childSAYsMessageList.filter(
            (each) => each.id !== id,
          );
          setChildSaysData({
            ...childSaysData,
            childSAYsMessageList: updatedData,
          });
          updateSaysCountInList(Parent_ID, "minus");
        } else {
          const copiedList = [...list];
          setList(copiedList.filter((each) => each.id !== id));
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const updateSaysCountInList = (id, operator) => {
    setList((prevList) => updateItemSayCount(prevList, id, operator));
  };
  const parentPrivateHashTag =
    data?.messageList?.find(
      (item) =>
        item?.Keyword_ID === "#TAG" &&
        item?.hashTagType?.toLowerCase() === "private" &&
        item.hashtagAccess === "N",
    ) || {};
  console.log(`modal data:`, data?.messageList?.at(-1));
  console.log(`parentPrivateHashTag:`, parentPrivateHashTag);

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        disableEscapeKeyDown
        disableAutoFocus
        style={{zIndex: 3000}}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "800px",
            maxHeight: "90vh",
            bgcolor: "#E5E4E2",
            borderRadius: "10px",
            boxShadow: 24,
            p: 2,
            overflow: "hidden",
            outline: "none",
          }}
        >
          {Object.keys(parentPrivateHashTag).length > 0 ? (
            <div>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                pl={1.5}
                height={40}
              >
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  style={{ paddingLeft: "10px" }}
                >
                  This is a Private TAG the activity is not public.
                </Typography>
                <IconButton
                  onClick={onClose}
                  style={{ margin: 0, padding: 4, outline: "none" }}
                >
                  <IoCloseOutline />
                </IconButton>
              </Box>
            </div>
          ) : (
            <div>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                pl={1.5}
                height={40}
              >
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  style={{ paddingLeft: "10px" }}
                >
                  {data?.wantedH || hashTag
                    ? formatTagTitle(data?.wantedH || hashTag)
                    : getNotificationActivityType(
                        notificationParentPost?.Keyword_ID,
                      )}
                </Typography>
                <IconButton
                  onClick={onClose}
                  style={{ margin: 0, padding: 4, outline: "none" }}
                >
                  <IoCloseOutline />
                </IconButton>
              </Box>
              {loading && (
                <div
                  style={{
                    marginBottom: 10,
                    marginTop: 10,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </div>
              )}
              {!notificationParentPost && <p style={{textAlign: "center"}}>No Record Found!</p>}
              <div style={{ maxHeight: "84vh", overflowY: "scroll" }}>
                <Post
                  ref={postRef}
                  loading={childSaysLoading}
                  listdata={list}
                  data={data}
                  childSaysData={childSaysData}
                  fetchChildSaysData={fetchChildSaysData}
                  postChildSayData={postChildSayData}
                  followData={followData}
                  fetchFollowData={fetchFollowData}
                  fetchVoteUpStatus={fetchVoteUpStatus}
                  deleteMessage={deleteMessage}
                  fetchFeedData={() => {}}
                  refreshFeedData={() => {}}
                  showData="tagsearch"
                  appendId="SearchTag"
                  hideTenantName={true}
                  parentMsgId={parentMsgId}
                  tagActivityTenantId={tagActivityTenantId}
                  isActionDisabled={isCommunityPrivate}
                  onActionSuccess={onActionSuccess}
                  onHashTagClick={handleHashTagClick}
                />
              </div>
              {isPrivate && (
                <Box
                  height={40}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography id="private-tag-description">
                    Only following users can view the message.
                  </Typography>
                </Box>
              )}
            </div>
          )}
        </Box>
      </Modal>
      {hasRestrictionSays && (
        <RestrictionMsgModal
          open={hasRestrictionSays}
          onClose={() => {
            setHasRestrictionSays(false);
            setHasRestrictionSaysStatus("");
          }}
          title="Thank you"
          message={`Your ${
            hasRestrictionSaysStatus === "E_Say" ? "Answer" : "Reply"
          } will publish as soon as the Community Moderator approves it.`}
        />
      )}
    </>
  );
};

export default SearchTagModal;
